module.exports = __webpack_public_path__ + "static/media/16UNODC24.8512ff88.jpg";